import { render, staticRenderFns } from "./StatusFlow.vue?vue&type=template&id=4b0e308a&scoped=true&lang=pug&"
import script from "./StatusFlow.vue?vue&type=script&lang=js&"
export * from "./StatusFlow.vue?vue&type=script&lang=js&"
import style0 from "./StatusFlow.vue?vue&type=style&index=0&id=4b0e308a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e308a",
  null
  
)

export default component.exports